import { NavigationReports } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { ProfitAndLossReport } from "@src/components/modules/reports/profit-and-loss";
import type { NavigationReportsProps } from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { DemoModule, Modules } from "@src/components/widgets/DemoModule";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/profit-and-loss",
  title: () => t`Profit & Loss`,
};

const Page = () => {
  return (
    <MainLayout
      title={report.title()}
      navigation={<NavigationReports currentReport={report} />}
    >
      <DemoModule module={Modules.Reports}>
        <ProfitAndLossReport report={report} />
      </DemoModule>
    </MainLayout>
  );
};

// export default withCan({ do: ["profitLossReport_query_all"] }, Page);

export const Route = createFileRoute("/reports/profit-and-loss")({
  component: Page,
});
